import React from 'react';
import classnames from 'classnames';
import { useOverlayContext } from '../../../../hooks/useOverlayContext';
import FaveControl from '../../../legos/FaveControl';
import CommentControl from '../../../legos/CommentControl';
import s from './BottomInfoBar.scss';
var BottomInfoBar = function (_a) {
    var deviation = _a.deviation, className = _a.className;
    var _b = useOverlayContext(deviation), showCommentControl = _b.showCommentControl, showFaveControl = _b.showFaveControl;
    return (React.createElement("div", { className: classnames(s['root'], className) },
        showFaveControl && (React.createElement(FaveControl, { deviation: deviation, className: s['stat'] })),
        showCommentControl && (React.createElement(CommentControl, { deviation: deviation, className: s['stat'] }))));
};
BottomInfoBar.displayName = 'BottomInfoBar';
export default BottomInfoBar;
//# sourceMappingURL=BottomInfoBar.js.map